import { render, staticRenderFns } from "./exp_asistencia_psico.vue?vue&type=template&id=17ae4fd2&scoped=true"
import script from "./exp_asistencia_psico.vue?vue&type=script&lang=js"
export * from "./exp_asistencia_psico.vue?vue&type=script&lang=js"
import style0 from "./exp_asistencia_psico.vue?vue&type=style&index=0&id=17ae4fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ae4fd2",
  null
  
)

export default component.exports